const MEDIA_TYPES = {
  video: 'video',
  img: 'img',
  gif: 'gif'
};
export default MEDIA_TYPES;
